import 'navigator.sendbeacon'
import _ from 'underscore'
import env from '@polleverywhere/core/lib/env'
import { batchCallFunction, deepDefaults } from '@polleverywhere/core/lib/util'
import { Cannon } from '@polleverywhere/cutlass'

// TODO: Cutlass needs an internal event builder method for batch events.
const toCutlassEventFormat = (name, props = {}) =>
  ({
    name,
    time: new Date(),
    properties: props,
    url: window.location.href,
    query_string: window.location.search
  })

const handleEvent = function (cannon, app, events) {
  cannon.accountId = app?.user?.get('account_id')
  cannon.userId = app?.user?.id
  cannon.addEvents(_.flatten(events))
}

/**
 * Sets up the cutlass cannon, batches events and listens to view:action' app events
 *
 * Calls within 1s are batched together and sent cutlass in bulk unless `immediate: true` is passed in as an option.
 */
export default function setupCannon (app, trackingOnHold = false) {
  const baseUrl = env.get('cutlass_base_url')

  if (!baseUrl) {
    return false
  }

  const cannon = new Cannon(baseUrl, {
    visitCookie: 'singularity_visit',
    visitorCookie: 'singularity_visitor',
    visitTTL: 1, // 1 hour
    visitorTTL: (365 * 24), // 365 days
    trackingOnHold
  })
  const eventHandler = _.partial(handleEvent, cannon, app)
  const batchHandleEvent = batchCallFunction(1000, eventHandler)

  app.on('view:action', (name, data = {}, opts = {}) => {
    data = deepDefaults(data,
      { event_type: 'view:action' }
    )

    if (opts.immediate) {
      eventHandler([toCutlassEventFormat(name, data)])
    } else {
      batchHandleEvent(toCutlassEventFormat(name, data))
    }
  })

  return cannon
}
